import {Main} from 'src/Layouts';
import {Drupal, Graphql, YouInvest} from 'src/Api';
import {InvestWithAjBell} from 'src/Components/Molecules/Card';
import {InstrumentMain, InstrumentInfoBoxes} from 'src/Components/Organisms';
import {SideNavigation} from 'src/Components/Molecules/Navigation';
import {getTitle, sendCacheHeaders} from 'src/Utils';
import {IncomeStatement as IncomeStatementCard} from './Components/Card';
import moment from 'moment';

export default function IncomeStatement({instrumentData}) {

    const getBreadCrumb = () => {
		if (instrumentData) {
			return `${instrumentData.quote.nameShort} (${instrumentData.quote.marketCode}) - Financials & ratios`;
		}
	}

    return <Main title={getTitle(instrumentData, 'Income statement')} nav={instrumentData.nav} breadcrumb={getBreadCrumb()} marketCode={instrumentData.quote.marketCode}>
        <div className="ajb-grid-row padding-bottom-20">
            <div className="ajb-col-2 ajb-col-8-breakpoint padding-top-20 padding-bottom-0-sm">
                <SideNavigation  {...instrumentData} />
                <InvestWithAjBell />
            </div>
            <div className="ajb-col-10 ajb-col-8-breakpoint main-content-wrapper white-bg margin-top-20 padding-20 padding-10-sm">
                <InstrumentMain {...instrumentData} />
                <InstrumentInfoBoxes {...instrumentData} />

                <div className="ab-grid-row clearfix"> 
                    <div className="ajb-col-collapse">
                        <IncomeStatementCard {...instrumentData} />                 
                    </div>
                </div>
            </div>
        </div>
    </Main>
}
  
export async function getServerSideProps(context) {

    const {marketCode} = context.query;
    const pageData = await YouInvest.getBasicPageData(marketCode);

    const query = `query pageData(
            $identifier: String!
            $startDate: String!, 
            $endDate: String!, 
            $statementType: StatementType!,
            $dataType: DataType!
        ) {
        incomeStatement(startDate:$startDate, endDate:$endDate, identifier: $identifier, statementType: $statementType, dataType: $dataType) { 
            currency
            yearEnd
            revenue
            expenses
            EBITDA
            EBIT
            operatingProfitReported
            investmentIncome
            exceptionalItems
            netInterest
            incomePreTax
            tax
            netProfit
            minorityInterests
            profitForFinancialYear
            ordinaryDividends
            retainedProfit
            dividendPerShare
            normalisedEarningsPerShare
            reportedEarningsPerShare
            operatingMargin
            dividendPerShareGrowth1Y
            dividendCover
            normalisedEarningsPerShareGrowth
            reportedEarningsPerShareGrowth
            operatingProfitAdjusted
        }
    }`;

    const endDate = moment(new Date()).format("MM/YYYY");
    const startDate = moment(moment(new Date()).subtract(72, 'months')).format("MM/YYYY");

    let instrumentData = {...pageData, ...(await Graphql.fetch(query, {
        identifier: marketCode,
        startDate: startDate,
        endDate: endDate,
        statementType: 'ANNUAL',
        dataType: 'RESTATED'
    }))};

    // Get first 5 years returned by incomeStatement
    const incomeStatement = instrumentData.incomeStatement.slice(0, 5);

    instrumentData = {
        ...instrumentData,
        incomeStatement
    };
    
    sendCacheHeaders(context, instrumentData);

    return { props: { instrumentData } }
}


